import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { IRenewTotal } from "@/interfaces/renew.interfaces";
import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import ISalesProduct from "@/interfaces/sales-product.interfaces";
import { RenewMessages } from "@/messages/renew/renew.messages";

import ProductImage from "./components/ProductImage";
import SubscriptionSummary from "./components/RenewSummary";

type Props = {
  messages: RenewMessages;
  salesProduct: ISalesProduct;
  salesProductPrice: ISalesProductPrice;
  totalPayment: IRenewTotal;
};

function ProductInfoCard({ messages, salesProduct, salesProductPrice, totalPayment }: Props) {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox variant="gradient" borderRadius="xl">
        <MDBox p={2}>
          <Grid container spacing={3} p={2} size={{ md: 12 }}>
            <ProductImage salesProduct={salesProduct} salesProductPrice={salesProductPrice} />

            <MDBox
              my={2}
              width={"100%"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              textAlign="center"
              gap={1}
            >
              <VerifiedUserIcon fontSize="medium" />

              <MDTypography variant="h5" fontWeight="regular">
                {messages.safeBuyLabel}
              </MDTypography>
            </MDBox>

            <SubscriptionSummary
              messages={messages}
              salesProductPrice={salesProductPrice}
              totalPayment={totalPayment}
            />
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ProductInfoCard;
